module.exports = __webpack_public_path__ + "ui-static/img/empty_light.65fb708f.svg";